/*
 * Project: BKN_FRONT
 * Copyright (c) 2024 Nttdata
 */
import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Box,
  Container,
  CircularProgress,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { NavBar } from "../../../components/PantallesBKI/Header/Header";
import { useRequeriment } from "../../../hooks/useRequeriment";
import Tipografia from "../../../components/Requeriment/Tipografia";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import "./formPeticio.css";

export default function Login(props) {
  const [isLoading, setIsLoading] = useState(false);
  const { postDades } = useRequeriment();
  localStorage.removeItem("dadesRequeriment");

  const handleSubmit = async (event) => {
    event.preventDefault();
    // Inicia la carga
    setIsLoading(true);

    const formData = new FormData(event.currentTarget);
    const nif = formData.get("nif");
    const numActuacio = formData.get("numActuacio");
    const numRegistreSortida = formData.get("numRegistreSortida");

    try {
      // Realiza la petición con los datos
      await postDades({
        nif: nif,
        numActuacio: numActuacio,
        numRegistreSortida: numRegistreSortida,
      });

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    document.title = `Cerca - Requeriment`;
  }, []);

  return (
    <Container component="main">
      <NavBar link="/requeriment" />
      <Box
        className="formPeticio-box"
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "white",

          textAlign: "center",
        }}
      >
        <Tipografia
          paddingLeft={1}
          key={2}
          variant={"h4"}
          style={{
            color: "#900000",
            marginBottom: "20px",
            fontSize: "160%",
            padding: "8px 0px",
          }}
          fontWeight={600}
          titol="Cerca la seva petició"
        />
        {isLoading ? (
          <CircularProgress />
        ) : (
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1, color: "#404040" }}
          >
            <div className="flex">
              <TextField
                color="primary"
                required
                fullWidth
                id="nif"
                label="NIF/DNI/NIE de la Raó social"
                name="nif"
                autoComplete="nif"
                autoFocus
              />
              <div>
                <Tooltip title="NIF/DNI/NIE de la raó social">
                  <IconButton>
                    <InfoIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </div>

            <div className="flex">
            <TextField
              margin="normal"
              required
              fullWidth
              name="numActuacio"
              label="Número d'actuació"
              type="text"
              id="numActuacio"
              autoComplete="current-actuacio"
            />
            <div>
                <Tooltip title="Número d'actuació">
                  <IconButton>
                    <InfoIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </div>

            <div className="flex">
            <TextField
              margin="normal"
              required
              fullWidth
              name="numRegistreSortida"
              label="Número de registre de sortida:"
              type="text"
              id="numRegistreSortida"
              autoComplete="current-registreSortida"
            />
            <div>
                <Tooltip title="Número de registre de sortida obtingut a la notificació">
                  <IconButton>
                    <InfoIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
            <Button
              className="btn_formPeticio"
              type="submit"
              variant="contained"
              sx={{
                width: "50%",
                padding: "10px",
                marginTop: "30px",
                backgroundColor: "#bf0000",
                color: "white",
                border: "none",
                borderRadius: "4px",
                "&:hover": {
                  backgroundColor: "#940101", // Cambia el color al hacer hover
                },
                cursor: "pointer",
              }}
            >
              Accedir
            </Button>
          </Box>
        )}
      </Box>
    </Container>
  );
}
